import { toNumber } from '../../../../core/utils/lp-backend';
import { writeSettingsFields } from './settings-fields';

/** `PATCH /client/settings/fields {cluster}`, with the lock fields nested under `lock` as cb stored them. */
export const editCluster = async (
  distance: number,
  size: number,
  lock_strategy: string,
  lock_time: number,
  collection_time_range: number
): Promise<any> =>
  writeSettingsFields({
    cluster: {
      distance: toNumber(distance),
      size: toNumber(size),
      lock: {
        strategy: lock_strategy,
        time: toNumber(lock_time),
        collection_time_range: toNumber(collection_time_range)
      }
    }
  });
